/**
 * Fix: Product slider clicks being swallowed by Swiper.
 * Swiper's default preventClicks + threshold:0 causes clicks
 * to be blocked when there's any tiny mouse movement.
 * This patch increases the threshold so small movements
 * during a click are not treated as swipe gestures.
 */
(function () {
  function patchProductSliders() {
    document
      .querySelectorAll('.popular-products-section .swiper')
      .forEach(function (el) {
        if (el.swiper && !el.dataset.clickPatched) {
          el.swiper.params.threshold = 10;
          el.dataset.clickPatched = 'true';
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Wait a tick for Swiper to initialize
    setTimeout(patchProductSliders, 500);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(patchProductSliders, 500);
  });
})();
